import React from 'react';
import './service-step-view.scss';
import { ServiceStepHandler } from '../../../components/sections/osb-v3/service-step/service-step-handler/service-step-handler';

export function ServiceStepView() {
    return (
        <div className="osb-v3-service-step-view-container">
            <ServiceStepHandler />
        </div>
    );
}
